import dayjs from 'dayjs'

export const formatDateTime = (value, format = 'YYYY-MM-DD hh:mm:ss A') => (value ? dayjs(value).format(format) : 'N/A')

export const formatDate = (value, format = 'MMMM DD, YYYY') => (value ? dayjs(value).format(format) : 'N/A')

export default {}
